// extracted by mini-css-extract-plugin
module.exports = {"calendarPage":"styles_calendarPage__DOjjL","sidePanel":"styles_sidePanel__r7gP3","selectedDate":"styles_selectedDate__7/A+G","calendarpanel":"styles_calendarpanel__6+YFN"};